import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_encouraged_sourcing_practices_that_resulted_in_the'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_encouraged_sourcing_practices_that_resulted_in_the',
  name: 'Has the facility encouraged sourcing practices that resulted in the facility sourcing from Small and Medium Enterprises and manufacturers that are owned by underrepresented minorities/protected groups, including women-owned businesses?',
  description: '',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ab-12',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 25310,
  sectionId: '2.2.2.4',
  impactArea: 'Community Impact',
  impactAreaId: 'COMMUNITY_IMPACT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
